import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import QaiScorecardChallengeQuestionsViewModel from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";
import TablePageControl from "./TablePageControl";

const styles = {
    tableCell: {
        padding: '4px 8px 4px 8px',
    },
}

interface IQaiChallengeTableProps {
    challengedQuestionsViewModel: QaiScorecardChallengeQuestionsViewModel
    handleChallengeOpen: (questionId: number, aiTemplateVersion: number) => void
    pageNumber: number
    changePage: (pageNumber: number) => void
}

export default function QaiChallengeTable({ challengedQuestionsViewModel, handleChallengeOpen, pageNumber, changePage }: IQaiChallengeTableProps) {
    return (
        <Grid size={12} height="100%">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={styles.tableCell}>Template Name</TableCell>
                        <TableCell sx={styles.tableCell}>Section Title</TableCell>
                        <TableCell sx={styles.tableCell}>Question Text</TableCell>
                        <TableCell sx={styles.tableCell}>AI Version</TableCell>
                        <TableCell sx={styles.tableCell}>Challenge Count</TableCell>
                        <TableCell sx={styles.tableCell}>State</TableCell>
                        <TableCell sx={styles.tableCell}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        challengedQuestionsViewModel.questions.map(challengedQuestion =>
                            <TableRow>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.templateName}</TableCell>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.sectionTitle}</TableCell>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.questionText}</TableCell>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.aiTemplateVersion}</TableCell>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.challengeCount}</TableCell>
                                <TableCell sx={styles.tableCell}>{challengedQuestion.state}</TableCell>
                                <TableCell sx={styles.tableCell}>
                                    <Button
                                        variant='contained'
                                        onClick={() => handleChallengeOpen(challengedQuestion.questionId, challengedQuestion.aiTemplateVersion)}>
                                        View challenge
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
            <TablePageControl
                challengedQuestionsViewModel={challengedQuestionsViewModel}
                changePage={changePage}
                pageNumber={pageNumber} />
        </Grid>
    )
}